module.exports = __webpack_public_path__ + "img/continue-button.9db84f3a.png";